import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import {storeData} from '../redux/store'
import { addUser } from '../redux/reducers/commonSlice';
import { useNavigate, Outlet } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';
import secureApi from '../helpers/secureApi';

export default function Auth() {

    const store = useSelector((state: storeData)=> state?.common);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [showContent, setShowContent] = useState(false);

    useEffect(()=>{
        if(store){
            if(store?.user){
                setShowContent(true);
            }
            else{
                let token = localStorage?.getItem("user");
                if(token){
                    checkLogin();
                }
                else{
                    navigate("/login");
                }
            }
        }
    }, [store]);

    const checkLogin= async ()=>{
        try{
            let userDetailApi = secureApi('userdetails');
            if(userDetailApi){
                let response = await axios.post(userDetailApi);
                //console.log("response", response);
                if(response?.data?.type==='success'){
                    dispatch(addUser(response?.data?.user));
                    setShowContent(true);
                }
                else{
                    navigate("/login");
                }
            }
            else{
                console.log("checkLogin, userdetails not found");
                navigate("/login");
            }
        }
        catch(error){
            console.log("checkLogin", error);
        }
    }

  return <>
  {showContent ? <Outlet /> : <Skeleton count={5} />}
  </>;
}